import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { propertyCardPhotoWrapperStyles } from './styles/property-card-photo-wrapper.styles';
import type { PropertyCardPhotoWrapperPropsInterface } from './types/property-card-photo-wrapper.types';

/**
 * Used by a `PropertyCard` to contain all of the parts of the property photo area
 * including the photo (or photo carousel), badges and MLS information.
 *
 * @since 8.63.0
 */
export const PropertyCardPhotoWrapper = forwardRef<
  HTMLDivElement,
  PropertyCardPhotoWrapperPropsInterface
>((props: PropertyCardPhotoWrapperPropsInterface, forwardedRef) => {
  const { children, className, css: cssProp, ...rest } = props;

  const styles = css(propertyCardPhotoWrapperStyles, cssProp);

  return (
    <div
      ref={forwardedRef}
      data-c11n-component="PropertyCard.PhotoWrapper"
      data-c11n-version={__C11N_VERSION__}
      className={cx('c11n', 'c11n_property-card__photo-wrapper', styles, className)}
      {...rest}
    >
      {children}
    </div>
  );
});

PropertyCardPhotoWrapper.displayName = 'PropertyCard.PhotoWrapper';
